import React from 'react';
import { CopilotGreeting } from './CopilotGreeting';
import { usePosterTemplateData } from '../../Home/hooks/usePosterTemplateData';
import PosterTemplateGallery from '../../Home/components/PosterTemplateGallery';
import { IPosterTemplate } from '../../Home/components/PosterTemplateGallery/types';
import './MagicPosterTabContent.scss';

interface IMagicPosterTabContentProps {
  onSelectTemplate: (template: IPosterTemplate) => void;
  /** 底部输入框区域高度（动态计算，避免列表被遮盖） */
  inputAreaHeight?: number;
}

// TODO: 组件过度分散，待合并到同一处
export const MagicPosterTabContent: React.FC<IMagicPosterTabContentProps> = ({
  onSelectTemplate,
  inputAreaHeight,
}) => {
  const { data: posterTemplates, loading: posterTemplatesLoading } = usePosterTemplateData();

  // 完全参照 DS 报告板块 DSAgentWrapper 的高度计算逻辑（index.tsx 第136行）：
  // topOffset = 390 = tab区域(62px) + 欢迎语约(100px) + 模板标题(约45px) + 安全余量(183px)
  // bottomOffset = 输入框高度 + 底部间距(40px)
  // 注意：CopilotGreeting 在滚动区域内（与 DS 报告板块结构一致），由外层容器负责滚动
  // 内嵌模式(docked)下面板不在视口顶部，动态计算面板距离视口顶部的实际偏移量
  const topOffset = 300;
  const bottomOffset = (inputAreaHeight || 90);
  const dockedPanel = document.querySelector<HTMLElement>('.dbh-agent-copilot--docked');
  const navOffset = dockedPanel ? dockedPanel.getBoundingClientRect().top - 70 : 0;

  return (
    /* 完全参照 DS 报告 CopilotDSHomeRecommendation 的结构：
     * 外层 .dbh-agent-landing-page 负责整体滚动（overflow-y: auto）
     * 内部 .dba-magic-poster-templates-section 设置 maxHeight 限制高度
     */
    <div className="dbh-agent-landing-page dba-copilot-magic-poster-landing-page">
      <CopilotGreeting tab="magicPoster" />
      <div
        className="dba-magic-poster-templates-section"
        style={{ maxHeight: `calc(100vh - ${navOffset + topOffset + bottomOffset}px)` }}
      >
        <PosterTemplateGallery
          templates={posterTemplates?.flatMap((group: any) => group?.list || [])}
          loading={posterTemplatesLoading}
          breakpointCols={2}
          onMakeSame={onSelectTemplate}
          className="dba-poster-gallery--copilot"
        />
      </div>
    </div>
  );
};
